import dynamic from 'next/dynamic';

const Map = dynamic(() => import('./map/map.component'), {
  ssr: false,
});

export {
    Map
}